import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Search } from 'lucide-react';

interface SearchBoxProps {
  className?: string;
  onSubmitted?: () => void;
}

/** 导航栏搜索框：提交后携带 keyword 跳转到博客列表 */
export default function SearchBox({ className, onSubmitted }: SearchBoxProps) {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState(searchParams.get('keyword') ?? '');

  // URL 变化时同步输入框（如点击标签、分页后）
  useEffect(() => {
    setKeyword(searchParams.get('keyword') ?? '');
  }, [searchParams]);

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    const value = keyword.trim();
    navigate(value ? `/blog?keyword=${encodeURIComponent(value)}` : '/blog');
    onSubmitted?.();
  };

  return (
    <form className={className ? `header-search ${className}` : 'header-search'} role="search" onSubmit={handleSubmit}>
      <Search size={15} className="header-search-icon" aria-hidden="true" />
      <input
        type="search"
        className="header-search-input"
        placeholder="搜索文章……"
        aria-label="搜索文章"
        maxLength={50}
        value={keyword}
        onChange={(event) => setKeyword(event.target.value)}
      />
    </form>
  );
}
